import { SingleEntityDataProvider } from '@contember/admin'
import * as React from 'react'

export const StandaloneEdit = SingleEntityDataProvider
